// @flow
import React, { Component } from 'react';
import { FlatList }         from 'react-native';
import { Inspection }       from 'types';
import { fetchConstants }   from 'actions/session.js';
import InspectionItem       from 'components/InspectionItem';

type Props = {
	inspections: Array<Inspection>,
};

type State = {
	inspClsLabel: Array<Object>,
};

class InspectionList extends Component {

	props: Props;
	state: State;

	constructor(props: Props) {

		super(props);
		this.state = { inspClsLabel: [] };
	}

	componentDidMount() {

		fetchConstants()
			.then((consts) => {

				const { inspClsLabel = null } = consts;

				if( inspClsLabel !== null )
					this.setState({ inspClsLabel });
			});
	}

	render() {

		const { inspections, history } = this.props;
		const { inspClsLabel } = this.state;

		// NOTE: `extraData` parameter must include anything outside of `data` that could
		//       alter <InspectionItem>
		return (
			<FlatList
				data={ inspections }
				extraData={ inspClsLabel }
				keyExtractor={(item, index) => item.id.toString()}
				renderItem={(lstObj) =>
					<InspectionItem
						inspection={lstObj.item}
						onPress={() => history.push(`/showInspection/${lstObj.item.id}`)}
						inspClsLabel={ inspClsLabel }
					/>
				}
			/>
		);
	}
}

export default InspectionList;

